/**
 * Singleton AbortController for the background upload-speed test.
 *
 * The speed test runs from HomePage and pushes ~15 MB of synthetic traffic
 * (3 rounds × 5 MB) to a Cloud Functions-issued signed URL. Today nothing
 * cancels it when the real upload starts, which:
 *   1) contends for upstream bandwidth on mobile, and
 *   2) biases per-chunk speed measurements in `Upload.ts` downward.
 *
 * Real-upload entry points call `abortSpeedTest()` to short-circuit any
 * in-flight test fetches and free the pipe for the actual chunked PUTs.
 *
 * Aborting replaces the controller so a subsequent test cycle (e.g. on a
 * later page mount) starts with a fresh, un-aborted signal.
 */

let controller = new AbortController();

export const getSpeedTestSignal = (): AbortSignal => controller.signal;

export const isSpeedTestAborted = (): boolean => controller.signal.aborted;

export const abortSpeedTest = (reason: string = 'aborted'): void => {
  if (!controller.signal.aborted) {
    controller.abort(reason);
  }
  controller = new AbortController();
};
